'use client';

import { GetPromoContentRequest } from '@/types/paged-requests/promo-content-paged-request';
import { commonFetch, CommonFetchResponse } from '@/utils/common-fetch';
import { buildUrlWithParams } from '@/utils/url-params';
import { PagedListOfPromoContent } from '@cinemark/content-api-client';

class PromotionalContentsApiService {
  private readonly promotionalContentsUrl = '/papi/promotional-contents';

  async getPromotionalContents(request: GetPromoContentRequest): Promise<CommonFetchResponse<PagedListOfPromoContent>> {
    const response = await commonFetch<PagedListOfPromoContent>(buildUrlWithParams(this.promotionalContentsUrl, request as unknown as Record<string, unknown>));
    return response;
  }
}

export const promotionalContentsApiService = new PromotionalContentsApiService();
